import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ColorDTO, SizeDTO } from '../../../../shared/models/model';
import { NotificationService } from 'src/app/shared/service/notification.service';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { LocalDataSource } from 'ng2-smart-table';
import Swal from 'sweetalert2';
import { colorService } from 'src/app/shared/service/color.service';

@Component({
  selector: 'app-size',
  templateUrl: './size.component.html',
  styleUrls: ['./size.component.scss']
})
export class SizeComponent implements OnInit {
  public closeResult: string;
  public sizeList: SizeDTO[]=[];
  public Size: SizeDTO = new SizeDTO();
  public Source:LocalDataSource;


  constructor(private modalService: NgbModal, private backService: colorService, private notifcationService: NotificationService, private toastr: ToastrService) {
    this.Source = new LocalDataSource();
    this.backService.getSize().subscribe(data => {
      this.sizeList = data;
      this.Source = new LocalDataSource(this.sizeList);
  });
    console.log(this.Source);
  }

  open(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  updateRecord(event) {
    this.Size.size1 = event.newData.description;
    this.Size.idSize = event.data["idsize"];
    // this.backService.updateColor(this.Color);
    // event.confirm.resolve(event.newData);
  }

  deleteRecord(event) {
    debugger
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        debugger
        console.log("test");
        this.Size = new SizeDTO();
        this.Size.idSize= event.data.idSize;
        console.log("id size", event.data.idSize);
        this.backService.deleteSize(event.data.idSize);
        event.confirm.resolve(event.newData);

        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        );
      }
    });


    
    
          
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  public settings = {
    "mode": "inline",
    delete: {
      "confirmDelete": "true"
    },
    edit: { "confirmSave": "true" },
    actions: {
      position: 'right',
      update: true
    },
    columns: {
      idsize: {
        title: 'IdSize'
      },
      size1: {
        title: 'Category'
      }
    },
  };
  ngOnInit() {
    this.Source = new LocalDataSource();
    this.loadGrid();
  }

  loadGrid() {
    this.backService.getSize().subscribe(data => {
      this.Source.refresh();
  });
  }


  onSubmit(contactForm) {
    this.Source.refresh();
    debugger
    console.log("size is ",contactForm.value);
    this.Size= new SizeDTO();
    this.Size.size1=contactForm.value["Size"];
    this.backService.addSize(this.Size);
    window.location.reload();
  }



}
function collapseAnimation() {
  throw new Error('Function not implemented.');
}

